import React, { useState, useEffect, useReducer, useCallback, useRef } from 'react';
import { Modal, Drawer, Space, Button, message } from 'antd';
// import { api, APIS } from '@/api';
import businessMatters from './businessMatters.json';
import KeepAlive from 'react-activation';
import { SActionBtn, SBack, SLowcodeList, STableActions } from 'shj-components'
import { isNil } from 'lodash-es';
import { businessMattersSearch } from '@/services/integrationConfig'
interface dataProps {
  open: boolean;
  showMode?: 'drawer' | 'modal'; //呈现方式
  config: any;
  type?: 'radio' | 'checkbox'; //多选/单选
  selectedRowKeys?: any[]; //回显的key
  selectedRow?: any[]; //回显的行数据(row)
  title?: string | JSX.Element;
  width?: number;
  mask?: boolean; //是否展示遮罩
  maskClosable?: boolean; //点击蒙层是否允许关闭
  onOk: (rows?: any) => void; //点击确定回调
  onCancel: () => void; //点击遮罩层或右上角叉或取消按钮的回调 modal
}
/**
 * 是否为有效的数组
 * @param arr 数组
 */
const isValidArray = (arr: any[]) => {
  return arr && Array.isArray(arr) && arr.length > 0 ? true : false;
};
// 业务事项选择列表
const BusinessMatters: React.FC<dataProps> = (props) => {
  const { open, showMode = 'modal', type = 'radio', title, width, onOk, onCancel } = props;
  const listRef = useRef<any>();
  const [_selectedRows, _setSelectedRows]: any = useState([]); //当前选中的row
  const [_selectedRowKeys, _setSelectedRowKeys]: any = useState([]); //当前选中的rowKeys

  //   ONLY_TRANSFER("only_transfer", "只转不传"),
  //   ONLY_SEND("only_send", "只传不转"),
  //   BOTH_TRANSFER_AND_SEND("both_transfer_and_send", "又转又传");
  const businessSystemArr = [
    { name: 'FMS', code: 'FMS' },
    { name: 'CRM', code: 'CRM' },
    { name: '供应链', code: 'SUPPLY_CHAIN' },
    { name: '交付', code: 'DELIVERY' },
    { name: 'OMS', code: 'OMS' },
    { name: 'WMS', code: 'WMS' },
    { name: 'HR', code: 'HR' },
    { name: '金蝶', code: 'KINGDEE' },
  ];
  useEffect(() => {
    if (!open) {
      listRef?.current?.resetSearch();
    }
  }, [open]);

  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        rest.query.status = true
        const data = await businessMattersSearch(current, pageSize, rest.query);
        const { records, total } = data;
        resolve({ records, total });
      } catch (e) {
        reject({ success: false });
      }
    });
  };
  const getStatusOptions = () => {
    return new Promise((resolve, reject) => {
      resolve({
        statusList: [
          {
            key: true,
            title: '启用',
          },
          {
            key: false,
            title: '禁用',
          },
        ],
        businessSystemArr,
      });
    });
  };
  const onEnableChange = (checked: any, record: any) => {
    console.log(checked, record);
    if (checked) {
      //   onEnable({ record });
    } else {
      //   onDisable({ record });
    }
  };

  const onEdit = useCallback((record) => {
    const [selectedRowKeys, selectedRows] = listRef.current.getSelectedRows && listRef.current.getSelectedRows();
    console.log(selectedRowKeys, selectedRows);
  }, []);

  const _onOk = () => {
    if (isNil(listRef?.current?.getSelectedRows())) {
      message.warning('请选择数据');
      return;
    }
    const [selectedRowKeys, selectedRows] = listRef?.current?.getSelectedRows && listRef?.current?.getSelectedRows();
    console.log(selectedRowKeys);
    console.log(selectedRows);
    if (!isValidArray(selectedRows)) {
      message.warning('请选择数据');
      return;
    }
    onOk && onOk(selectedRows);
  };

  const onSave = () => {};

  const extension = {
    request: { fetchList, getStatusOptions },
    // events: { onAdd, onEnable, onDisable, onEnableChange },
    events: { onEnableChange },
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      statusCell(text: any) {
        return text ? '启用' : '禁用';
      },
      // 渲染操作栏
      renderOperate(_text: string, _record: object) {
        return (
          <div className="actionBox">
            {/* <STableActions> */}
              {/* <ActionBtn datareskey="receiptRulesButton4" primary onClick={() => onEdit(record)}>
                编辑
              </ActionBtn> */}
              {/* <ActionBtn datareskey="receiptRulesDetail" onClick={() => onLook(record)}>
                明细
              </ActionBtn>
              <Popconfirm title={'是否删除？'} onConfirm={() => onDel(record)} okText="确定" cancelText="取消">
                <ActionBtn datareskey="receiptRulesButton5" alarm>
                  删除
                </ActionBtn>
              </Popconfirm> */}
            {/* </STableActions> */}
          </div>
        );
      },
    },
  };

  //   const rowSelection = {
  //     type: type,
  //     selectedRowKeys: _selectedRowKeys,
  //     onChange: onSelectChange,
  //   };

  //   businessMatters.rowSelectionType = type;
  //   businessMatters.rowKey = 'code';

  //   console.log(businessMatters);
  //   console.log(listRef);
  //   console.log(listRef?.current?.getSelectedRows && listRef?.current?.getSelectedRows());

  return (
    <>
      {showMode === 'modal' && (
        <Modal visible={open} title={title || '数据选择'} width={width || 860}>
          <SLowcodeList
            config={{ ...businessMatters, tableType: 'antd', rowSelectionType: 'radio' }}
            ref={listRef}
            //   rowSelection={rowSelection}
            {...extension}
          />
        </Modal>
      )}
      {showMode === 'drawer' && (
        <Drawer
          visible={open}
          title={title || '数据选择'}
          width={width || 860}
          onClose={onCancel}
          extra={
            <Space>
              <Button onClick={onCancel}>关闭</Button>
              {/* <Button onClick={() => onOk(_selectedRows)} type="primary" disabled={!isValidArray(_selectedRows)}> */}
              <Button onClick={() => _onOk()} type="primary">
                确定
              </Button>
            </Space>
          }
        >
          <SLowcodeList
            config={{ ...businessMatters, tableType: 'antd', rowSelectionType: 'radio' }}
            ref={listRef}
            //   rowSelection={rowSelection}
            {...extension}
          />
        </Drawer>
      )}
    </>
  );
};
export default BusinessMatters;
